import get from "lodash/get";
import { TFunction } from "next-i18next";

import { IconCarPaid, IconMug, IconPaw, IconSilverware } from "icons";
import { IconComponent } from "icons/react/Icon";
import { IconCroissant } from "icons/react/IconCroissant";
import { Upgrade, UpgradeService } from "types/graphql";

const enum UpgradeSubType {
  HOT_BREAKFAST = "Hot breakfast",
  CONTINENTAL_BREAKFAST = "Continental breakfast",
}

export const getUpgradeConfig = (upgrade: UpgradeService, t: TFunction) => {
  return {
    Icon: _getIcon(upgrade),
    titleTranslateKey: _getTitleTranslateKey(upgrade),
    price: _getPrice(upgrade, t),
  };
};

function _getIcon(upgrade: UpgradeService) {
  const upgradeIconMap: Record<Upgrade | UpgradeSubType, IconComponent> = {
    [Upgrade.Parking]: IconCarPaid,
    [Upgrade.Pet]: IconPaw,
    [Upgrade.Breakfast]: IconSilverware,
    [UpgradeSubType.CONTINENTAL_BREAKFAST]: IconCroissant,
    [UpgradeSubType.HOT_BREAKFAST]: IconMug,
  };

  return get(upgradeIconMap, upgrade.subType ?? upgrade.type);
}

function _getTitleTranslateKey(upgrade: UpgradeService) {
  const upgradeTranslations: Record<Upgrade | UpgradeSubType, string> = {
    [Upgrade.Parking]: "listing:upgrades.parking.title",
    [Upgrade.Pet]: "listing:upgrades.pet.title",
    [Upgrade.Breakfast]: "listing:upgrades.breakfast.title",
    [UpgradeSubType.CONTINENTAL_BREAKFAST]:
      "listing:upgrades.breakfast.continental.title",
    [UpgradeSubType.HOT_BREAKFAST]: "listing:upgrades.breakfast.hot.title",
  };

  return get(upgradeTranslations, upgrade.subType ?? upgrade.type);
}

function _getPrice(upgrade: UpgradeService, t: TFunction) {
  const multiPrice = t("listing:intro.pricesVary");

  return upgrade.type === Upgrade.Pet
    ? multiPrice
    : `+${upgrade.displayPrice} ${_formatScheduleType(upgrade, t)}`;
}

function _formatScheduleType(upgrade: UpgradeService, t: TFunction) {
  const { scheduleType, type } = upgrade;
  const per = t("listing:intro.per");

  if (type === Upgrade.Breakfast) {
    const breakfastScheduleType =
      scheduleType?.[0] === "/" ? scheduleType.slice(1) : scheduleType;
    return `${per} ${breakfastScheduleType}`;
  }

  return scheduleType;
}
